import React from "react"
import { EditBandFormField } from "./EditBandFormField"
import { handleUpdateBandData } from "../BandEditPage"
import { Band } from "../../types/bands"

interface IsLocationSecretProps {
  band: Band
}

interface SelectOption {
  value: string | null
  label: string
  description?: string
}

interface ApiResponse {
  success: boolean
  errors?: {
    error: string
  }
}

export const IsLocationSecret: React.FC<IsLocationSecretProps> = ({ band }) => {
  const customOnSubmit = async (
    data: Record<string, any>,
  ): Promise<ApiResponse> => {
    // data will be { additional_info: { is_location_secret: value } } from EditBandFormField
    return (await handleUpdateBandData(band.id, {
      additional_info: {
        is_location_secret: data.additional_info?.is_location_secret || null,
      },
    })) as ApiResponse
  }

  const options: SelectOption[] = [
    { value: null, label: "Select location visibility..." },
    {
      value: "no",
      label: "No",
      description: "Exact location will be displayed publicly",
    },
    {
      value: "after_validation",
      label: "Yes - share after validation",
      description:
        "Only logged in people can see it after they have verified their email address (city is shown publicly)",
    },
    {
      value: "tickets_only",
      label: "Share in ticket emails only",
      description:
        "People will receive the specific address and entrance instructions in an email after they buy a ticket to an event (city is shown publicly)",
    },
  ]

  const fieldData = {
    field: "additional_info.is_location_secret",
    name: "isLocationSecret",
    label: "Is Location Secret?",
    placeholder: "Select location visibility",
    required: false,
  }

  return (
    <EditBandFormField
      type="select"
      fieldData={fieldData}
      bandId={band.id}
      options={options}
      onSubmit={customOnSubmit}
    />
  )
}
